import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { Entity } from './Entity';
import { useEntityVersionWithKindVersion } from '../../../loaders/useEntityVersionWithKindVersion';
import { useRootStore } from '../../../loaders/useRootStore';
import { usePageTitle } from '../pageTitleContext/PageTitleContext';
import { YoAlert } from '@yakoffice/shared-components';

export const EntityContainer: FC = observer(() => {

    const rootStore = useRootStore();
    const entityVersionResult = useEntityVersionWithKindVersion();
    const { setPageTitle } = usePageTitle();

    useEffect(() => {
        const title = (entityVersionResult.entityVersion !== null && entityVersionResult.entityVersion.isNewEntity()) ? 'New' : (entityVersionResult.entityVersion !== null ? entityVersionResult.entityVersion.name : '');
        setPageTitle([title, rootStore.kindVersionStore.currentKindVersion ? rootStore.kindVersionStore.currentKindVersion.name : 'Kind', rootStore.categoryStore.currentCategory ? rootStore.categoryStore.currentCategory.name : 'Configurations']);
    });

    return (
        <div id="entity">
            {entityVersionResult.isLoaded ?
                <div>
                    {entityVersionResult.entityVersion !== null && entityVersionResult.kindVersion !== null ?
                        <Entity project={rootStore.projectStore.getCurrentProject()}
                                gameVersion={rootStore.gameVersionStore.getCurrentGameVersion()}
                                category={rootStore.categoryStore.getCurrentCategory()}
                                gameEnvironment={rootStore.gameEnvironmentsStore.getCurrentGameEnvironment()}
                                currentKindVersion={rootStore.kindVersionStore.getCurrentKindVersion()}
                                entityVersion={entityVersionResult.entityVersion}
                                entityVersionKindVersion={entityVersionResult.kindVersion}
                                specificationKindVersions={rootStore.specificationsForKindsStore.getKinds()}
                                gameEnvironments={rootStore.gameEnvironmentsStore.gameEnvironments}
                        />
                        : <YoAlert text={'Could not find entity version'} />}
                </div>
                : <CustomSpinner spinnerText={'Loading entity...'} />
            }
        </div>
    );
});
